import { Pipe, PipeTransform } from "@angular/core";

interface PriceProps {
  currency?: string;
  decimal?: number;
  showSymbol?: boolean;
}

@Pipe({
  name: "priceFormatter",
  pure: true,
})
export class PriceFormatterPipe implements PipeTransform {
  defaultOpt: PriceProps = {
    currency: "EUR",
    decimal: 2,
    showSymbol: false,
  };

  transform(amount: number, opt: Partial<PriceProps> = null): string {
    opt = { ...this.defaultOpt, ...opt };

    if (!amount) {
      if (amount !== 0) {
        return "-";
      } else {
        if (opt.decimal === 0) {
          return "0";
        } else {
          return "0.00".replace(".", ",");
        }
      }
    } else {
      // Format the amount based on decimal places
      let formattedAmount: string;

      if (opt.decimal === 0) {
        // If decimal is 0, don't round off, just show as integer
        formattedAmount = Math.floor(amount).toString();
      } else {
        // Limit to max 2 decimal digits
        const maxDecimal =
          opt.decimal !== undefined && opt.decimal <= 2 ? opt.decimal : 2;
        formattedAmount = Number(amount).toFixed(maxDecimal);
      }

      // Replace decimal point with comma as per European format
      const formattedPrice = formattedAmount.replace(".", ",");

      // Add currency symbol only if requested
      if (opt.showSymbol && opt.currency) {
        switch (opt.currency) {
          case "EUR":
            return `€${formattedPrice}`;
          case "USD":
            return `$${formattedPrice}`;
          default:
            return `${opt.currency} ${formattedPrice}`;
        }
      }

      return formattedPrice;
    }
  }
}
